import { AppUtil } from './AppUtil'
import { DateUtil } from './DateUtil'
import { StringUtil } from './StringUtil'
import { BrowserUtil } from './BrowserUtil'

export type TrackInfoType = {
  trackId: string
  event: {
    name: string
    convert_id: string
  }
}
export type AccountDetailType = {
  account_id: string
  action_id: string
}
export type AccountConfigType = {
  channel: string
  accounts: AccountDetailType[]
}
export interface TencentGlobal extends Window {
  gdt?: any
  version?: any
}
interface ZhihuGlobal extends Window {
  zhad?: any[]
}

export class AdChannel {
  public static isChannel(channel: string, channel_prefix: string): boolean {
    if (channel) {
      return channel.startsWith(channel_prefix)
    } else {
      return false
    }
  }

  public static isBaiduChannel(channel: string) {
    return this.isChannel(channel, 'baidu_')
  }

  public static isZhihuChannel(channel: string) {
    return this.isChannel(channel, 'zhihu')
  }

  public static isTouTiaoChannel(channel: string) {
    return this.isChannel(channel, 'toutiao')
  }

  public static isTencentChannel(channel: string) {
    return this.isChannel(channel, 'tencent')
  }

  public static isTocChannel(channel: string) {
    return this.isChannel(channel, 'toc_')
  }

  public static isTobChannel(channel: string) {
    return this.isChannel(channel, 'tob_')
  }

  public static isTobTouTiaoChannel(channel: string) {
    return this.isChannel(channel, 'tob_toutiao')
  }

  public static isTouTiaoTyjxChannel(channel: string) {
    return this.isChannel(channel, 'toutiao_tyjx')
  }

  public static isTobTencentChannel(channel: string) {
    return this.isChannel(channel, 'tob_tencent')
  }

  public static isStuChannel(channel: string) {
    return this.isChannel(channel, 'tostu')
  }

  public static isHomeworkChannel(channel: string) {
    return this.isChannel(channel, 'homework')
  }

  public static isHomeworkSummerChannel(channel: string) {
    return this.isChannel(channel, 'homework_summer')
  }

  public static isHomeworkSummerTencentChannel(channel: string) {
    return this.isChannel(channel, 'homework_summer_tencent')
  }

  public static isHomeworkWinterChannel(channel: string) {
    return this.isChannel(channel, 'homework_winter')
  }

  public static isHomeworkTouTiaoChannel(channel: string) {
    return this.isChannel(channel, 'homework_toutiao')
  }

  public static async channelWithEnv(channel: string) {
    //  1. 如果投放channel存在，则优先传递
    if (channel && channel.trim()) {
      return channel
    }
    //  2. 否则判断是否是 app 环境， 是则传递 channel= app_channel
    if (await AppUtil.isUnderApp()) {
      return 'app_channel'
    }
    //  3. 否则判断是不是 wechat 环境， 是则传递 channel = wechat_channel
    if (await BrowserUtil.isWechat()) {
      return 'wechat_channel'
    }
    // 4.都不满足，则直接返回, 逻辑上不应该执行到，因为此时channel为空或者空格
    return channel
  }
}

export class TikTokAd extends AdChannel {
  private static win: any

  public static accountInfo: TrackInfoType[] = []

  static isDouYinBaseCodeInit: boolean

  public static isOcpcPage() {
    const ocpc_pages = ['#/ad-mobile-activity', '#/auth-form', '#/ad-auth-form', '#/ad-pc-activity']

    return ocpc_pages.indexOf(location.pathname) > -1 || ocpc_pages.indexOf(location.hash.split('?')[0]) > -1
  }

  // (window, document, "script", trackid);
  public static douyinTrackInit(r: any, d: Document, s: string, trackid: string) {
    const meteor = (r.meteor = r.meteor || [])
    meteor.methods = ['track', 'off', 'on']
    meteor.factory = function (method: any) {
      return function () {
        // eslint-disable-next-line prefer-rest-params
        const args = Array.prototype.slice.call(arguments)
        args.unshift(method)
        meteor.push(args)
        return meteor
      }
    }

    for (let i = 0; i < meteor.methods.length; i++) {
      const key = meteor.methods[i]
      meteor[key] = meteor.factory(key)
    }

    meteor.load = function () {
      const fjs: any = d.getElementsByTagName(s)[0]
      const js: any = d.createElement(s)
      js.src = 'https://analytics.snssdk.com/meteor.js/v1/' + trackid + '/sdk'
      fjs.parentNode.insertBefore(js, fjs)
    }

    meteor.load()
    if (meteor.invoked) {
      return
    }
    meteor.invoked = true
    meteor.track('pageview')
  }

  public static douyinFormSubmit() {
    this.accountInfo.forEach((item) => {
      this.win.meteor.track(item.event.name, { convert_id: item.event.convert_id })
    })
  }

  public static douYinChannelInit(ticTokTrackIdInfo: TrackInfoType[]) {
    this.win = window as any
    const meteor = (this.win.meteor = this.win.meteor || [])
    if (Object.prototype.toString.call(meteor) === '[object Object]') {
      // metor 已经初始化
      return false
    }
    ticTokTrackIdInfo.forEach((item) => {
      this.douyinTrackInit(this.win, document, 'script', item.trackId)
    })
  }

  public static baseCodeInit() {
    this.isDouYinBaseCodeInit = false
    this.douYinChannelInit(this.accountInfo)
    this.isDouYinBaseCodeInit = true
  }

  public static submitForm() {
    if (this.isDouYinBaseCodeInit) {
      this.douyinFormSubmit()
    }
  }

  public static validatePhone(phone: string) {
    if (phone.length !== 11) {
      return {
        error: true,
        msg: '请您填写11位手机号',
      }
    }
    const isPhone = StringUtil.validateChinaMobilePhoneNumber(phone)
    if (!isPhone) {
      return {
        error: true,
        msg: '手机号码格式不正确，请检查',
      }
    }

    return {
      error: false,
      msg: '',
    }
  }
}

export class TencentAd extends AdChannel {
  public static win: TencentGlobal = window
  public static doc: Document = document
  public static tag = 'script'
  public static gdtEventsJs = '//qzonestyle.gtimg.cn/qzone/biz/gdt/dmp/user-action/gdtevent.min.js'
  public static version: any
  public static accountInfo: TrackInfoType[] = []

  public static initBaseCode() {
    if (this.win.gdt) return
    this.initVersion()
    this.initScript()
    this.initAccountInfo()
  }

  public static initVersion() {
    this.version = this.win.gdt = (...args: any[]) => {
      this.win.gdt.tk
        ? // eslint-disable-next-line prefer-spread
          this.win.gdt.tk.apply(this.win.gdt, args)
        : this.win.gdt.queue.push(args)
    }

    this.version.sv = '1.0'
    this.version.bt = 0
    this.version.queue = []
  }

  public static initScript() {
    const scriptEle = this.doc.createElement(this.tag) as HTMLScriptElement
    scriptEle.async = !0
    scriptEle.src = this.gdtEventsJs
    const firstScript = this.doc.getElementsByTagName(this.tag)[0]
    if (firstScript && firstScript.parentNode) {
      firstScript.parentNode.insertBefore(scriptEle, firstScript)
    }
  }

  public static initAccountInfo() {
    this.accountInfo.forEach((account) => {
      this.win.gdt('init', account.event.convert_id)
      this.win.gdt('track', 'PAGE_VIEW')
    })
  }

  public static submitForm() {
    const time = DateUtil.longDateStr(new Date())
    this.win.gdt('track', 'RESERVATION', { time })
  }

  public static homeworkSummerBaseCodeInit() {
    this.initBaseCode()
  }
}

export class BaiduAd extends AdChannel {
  private static win: any
  static isBaiduBaseCodeInit: boolean

  public static baiduOcpcSubmit(): void {
    this.win._agl && this.win._agl.push(['track', ['success', { t: 3 }]])
  }

  public static baiduBaseCodeInit(win: any): void {
    win._agl.push(['production', '_f7L2XwGXjyszb4d1e2oxPybgD'])
    ;(function () {
      const agl = document.createElement('script')
      agl.type = 'text/javascript'
      agl.async = true
      agl.src = 'https://fxgate.baidu.com/angelia/fcagl.js?production=_f7L2XwGXjyszb4d1e2oxPybgD'
      const s = document.getElementsByTagName('script')
      if (s && s[0] && s[0].parentNode) {
        s[0].parentNode.insertBefore(agl, s[0])
      }
    })()
  }

  public static addOcpcBaseCode() {
    this.win = window as any
    this.win._agl = this.win._agl || []
    this.baiduBaseCodeInit(this.win)
  }

  public static pageInit(channel: string) {
    this.isBaiduBaseCodeInit = false
    if (this.isChannel(channel, 'baidu_')) {
      this.addOcpcBaseCode()
      this.isBaiduBaseCodeInit = true
    }
  }
}

export class ZhihuAd extends AdChannel {
  private static win: ZhihuGlobal = window
  private static isZhihuBaseCodeInit = false
  private static readonly jsSource = '//unpkg.zhimg.com/@efe/zhad-tracker@1.4.1'

  public static addOcpcBaseCode() {
    this.win.zhad = []
    const tag = document.createElement('script')
    tag.type = 'text/javascript'
    tag.async = true
    tag.src = this.jsSource
    tag.onerror = function () {
      const img = new Image()
      img.src = '//sugar.zhihu.com/log_fe?js_url=' + window.encodeURIComponent(tag.src) + '&t=' + +new Date()
    }

    const scriptTags = document.getElementsByTagName('script')
    if (scriptTags && scriptTags[0] && scriptTags[0].parentNode) {
      scriptTags[0].parentNode.insertBefore(tag, scriptTags[0])
    }
  }

  public static pageInit(channel: string) {
    this.isZhihuBaseCodeInit = false
    if (this.isChannel(channel, 'zhihu')) {
      this.addOcpcBaseCode()
      this.isZhihuBaseCodeInit = true
    }
  }

  public static submitForm() {
    ;(this.win.zhad as any[]).push({ eventtype: 'js_submit' })
  }
}
